import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { doFetch } from '../redux/api/actions';
import { useParams } from "react-router-dom";
import { GET_PUBLIC_USER } from '../redux/api/constants';
import withLayout from './withLayout';
import { displayList } from './recipeList';

function PublicProfile() {
    const { username } = useParams();
    const dispatch = useDispatch()
    const recipes = useSelector(state => state.API.recipes);

    useEffect(() => {
        dispatch(doFetch(
            GET_PUBLIC_USER,
            `recipes?username=${username}`
        ))
    }, [dispatch, username]);

    return (
        <>
            <div>
                <h1>{username}</h1>
                <p>Recipes</p>
                {displayList(recipes)}
            </div>
        </>
    );
}
export default withLayout(PublicProfile);